var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustra04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 120,
    viewBox: "0 0 275 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3428_17362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9417 37.3634V55.7005M90.947 53.4353L94.2956 50.1166L99.3243 53.5654L103.393 48.602L107.641 53.6963C111.625 53.7582 114.92 50.408 114.854 46.2135C114.787 42.019 111.625 38.5685 107.641 38.5067L83.2758 38.1708V37.0858C83.1716 30.4944 78.2014 25.0723 71.9417 24.9751C65.6821 24.8779 60.3491 30.1425 60.4533 36.7339V56.2634C60.5575 62.8548 65.6821 68.2769 71.9417 68.3741C78.2014 68.4713 83.38 63.2067 83.2758 56.6154V53.3604L90.947 53.4353Z",
    stroke: "#FF6956",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.367 49.4129C147.037 49.4129 150.012 46.4376 150.012 42.7675C150.012 39.0973 147.037 36.1221 143.367 36.1221C139.696 36.1221 136.721 39.0973 136.721 42.7675C136.721 46.4376 139.696 49.4129 143.367 49.4129Z",
    stroke: "#CCCEDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.314 56.6744C160.751 56.6744 162.726 54.6988 162.726 52.2618C162.726 49.8249 160.751 47.8493 158.314 47.8493C155.877 47.8493 153.901 49.8249 153.901 52.2618C153.901 54.6988 155.877 56.6744 158.314 56.6744Z",
    stroke: "#CCCEDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6708 90.2062C109.713 90.2062 129.202 70.7164 129.202 46.6746C129.202 22.6327 109.713 3.14294 85.6708 3.14294C61.6289 3.14294 42.1392 22.6327 42.1392 46.6746C42.1392 70.7164 61.6289 90.2062 85.6708 90.2062Z",
    stroke: "#CCCEDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.424 104.015V109.764M148.424 109.764H147.642C129.081 109.764 129.081 135.265 147.642 135.265H148.424M148.424 109.764V135.265M148.424 135.265C150.176 151.036 165.248 164.579 183.088 164.579C200.927 164.579 215.827 151.036 217.579 135.265M217.579 135.265H218.663C237.224 135.265 237.224 109.764 218.663 109.764H217.751M217.579 135.265L217.751 109.764M217.751 109.764V104.015C217.751 100.655 217.272 97.4063 216.378 94.3341M203.597 94.2932C200.142 89.6167 192.643 89.8394 188.81 93.2804M163.654 95.6879C167.108 91.9649 174.607 92.1422 178.44 94.8816M176.86 115.254C176.86 105.86 165.157 105.86 165.157 115.254C165.157 124.166 176.86 124.166 176.86 115.254ZM200.594 115.254C200.594 105.86 188.89 105.86 188.89 115.254C188.89 124.24 200.594 124.24 200.594 115.254Z",
    stroke: "#FF6956",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.178 70.2735L161.658 76.2705L175.328 53.3945L195.399 70.9265L215.876 57.9674L216.126 93.4428L148.163 104.473L138.178 70.2735Z",
    stroke: "#FF6956",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3428_17362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 120,
    fill: "white",
    transform: "translate(0.36145)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustra04);
export default __webpack_public_path__ + "static/media/illustra_04.fb84fe020fb52cac94a3d0da60075b88.svg";
export { ForwardRef as ReactComponent };